import { Button } from 'core/components/ui/Button';
import { Result } from 'core/components/ui/Result';

import { BACK_HOME, SUBTITLE_CODE_403 } from './literals';

export function ForbiddenErrorPage(): JSX.Element {
  return (
    <Result
      extra={<Button href="/">{BACK_HOME}</Button>}
      status="403"
      subTitle={SUBTITLE_CODE_403}
      title="403"
    />
  );
}
